import React, { useContext, useState } from 'react';
import { View, Pressable } from 'react-native';
import PropTypes from 'prop-types';
import { AlternatingTextPlusImage } from './AlternatingTextPlusImage';
import { H1, H5 } from '../../text';
import LayoutContext from '../../../contexts/Layout';
import Utils from '../../../common/Utils';

const TabbedAlternatingContainer = ({ contentItems, followContentLink = () => {}, nodeTypeAlias = 'TabbedAlternatingContainer', references, title, hardWidth }) => {
    const { layout } = useContext(LayoutContext);
    const [active, setActive] = useState(0);
    const tabs = Object.values(contentItems);

    if (tabs?.length === 0) {
        return null;
    }

    const activeTab = Object.values(tabs[active].contentItems ?? {});

    return (
        <View
            style={{ marginBottom: layout.styleGuide.componentSeparator }}
            dataSet={{ umbracoComponentName: nodeTypeAlias, spacerBottom: 'StyleGuide.ComponentSeparator(layout.styleGuide.componentSeparator)' }}
        >
            <TabButtonsGroup {...{ layout, active, setActive, tabs, title }} />
            {activeTab.map((tabItem, index) => {
                if (typeof tabItem === 'object') {
                    return (
                        <AlternatingTextPlusImage
                            {...Utils.splitKeyFromProps(tabItem).rest}
                            followContentLink={followContentLink}
                            key={index}
                            order={index}
                            references={references}
                            width={hardWidth}
                        />
                    );
                }
            })}
        </View>
    );
};

const TabButtonsGroup = ({ layout, active, setActive, tabs, title }) => (
    <View dataSet={{ umbracoComponentName: tabs[active].nodeTypeAlias }}>
        <View style={{ alignItems: 'center' }}>
            <H1 style={{ marginBottom: layout.styleGuide.spacer2 }} text={title} />
        </View>
        <View style={{ flexDirection: 'row', justifyContent: 'space-evenly' }}>
            {tabs.map((tab, index) => {
                return (
                    <Pressable key={index} onPress={() => setActive(index)} style={active === index ? { borderBottomColor: '#a61a2b', borderBottomWidth: 2 } : null}>
                        <H5 style={{ color: active === index ? '#a61a2b' : '#7f868b', marginBottom: layout.styleGuide.spacer3 }} text={tab.tabName} />
                    </Pressable>
                );
            })}
        </View>
    </View>
);

TabbedAlternatingContainer.propTypes = {
    contentItems: PropTypes.object,
    followContentLink: PropTypes.func,
    references: PropTypes.object,
    title: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default TabbedAlternatingContainer;
